import React from 'react';
import PropTypes from 'prop-types';

const ResponseErrorMessage = props => {
	const { error } = props;

	return (
		<div className={'error-message-box'}>
			<i className="fas fa-exclamation-triangle"></i> Error Status
			: { error.status } : { error.statusText }
		</div>
	);
};

ResponseErrorMessage.propTypes = {
	error: PropTypes.object
};

export default ResponseErrorMessage;
